/*
 *   File : update-fatca.js
 *   Author : https://evoqins.com
 *   Description : Update nominee info modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "bootstrap";
import { format, subYears } from "date-fns";
import { toast } from "react-toastify";

//custom component
import { PrimaryButton } from '../Buttons';
import { CustomTextInput, DatePicker } from "../Form-Elements";
import SelectionSuggestModal from "./select-suggestion";
import { APIService } from "../../Service";

import Success from "../../Assets/Images/success.webp";

const UpdateKYCFATCADetailsModal = (props) => {

    const PROGRESS_DATA = useSelector((store) => store.Reducer.SIGNUP_PROGRESS_DATA);
    const [isTaxProofTIN, setIsTaxProofTin] = useState(false);
    const [isNonIndianTaxPayer, setIsNonIndianTaxPayer] = useState(false);
    const [userData, setUserData] = useState({});
    const [currentStep, setCurrentStep] = useState(1); // 1 - Starting, 2 - Details, 3 - Success or failure 
    const [countryData, setCountryData] = useState([]);
    const [showNationalityModal, setShowNationalityModal] = useState(false);
    const [selectedNationality, setSelectedNationality] = useState([]);
    const [nationalityError, setNationalityError] = useState("");
    const [placeOfBirth, setPlaceOfBirth] = useState("");
    const [placeOfBirthError, setPlaceOfBirthError] = useState("");
    const [taxReferenceNumber, setTaxReferenceNumber] = useState("");
    const [taxReferenceNumberError, setTaxReferenceNumberError] = useState("");
    const [taxResidencyFromDate, setTaxResidencyFromDate] = useState("");
    const [taxResidencyFromDateError, setTaxResidencyFromDateError] = useState("");
    const [taxResidencyToDate, setTaxResidencyToDate] = useState("");
    const [taxResidencyToDateError, setTaxResidencyToDateError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        _getCountry();
        _getUserData(); // getting user data 
    }, []);

    useEffect(() => {
        if (PROGRESS_DATA) {
            const kyc_data = PROGRESS_DATA?.kyc_data || {};
            setIsTaxProofTin(kyc_data.reference_proof_id === 65);
            setIsNonIndianTaxPayer(kyc_data.is_indian_tax_payer === false);
        }
    }, [PROGRESS_DATA]);

    useEffect(() => {
        if (showNationalityModal === true) {
            let nationality_modal = new Modal(document.getElementById('select-nationlaity-modal'));
            nationality_modal.show();
        }

    }, [showNationalityModal]);

    // handle select nationality
    const _handleSelectNationality = (value) => {
        setSelectedNationality(value);
        setNationalityError("");
    };

    // New change
    const _handlePlaceOfBirthChange = (value) => {
        setPlaceOfBirth(value);
        setPlaceOfBirthError("");
    };

    const _handleChangeTaxReference = (value) => {
        setTaxReferenceNumber(value)
        setTaxReferenceNumberError("");
    };


    const _handleUpdateTaxResidencyFrom = (date) => {
        setTaxResidencyFromDate(date);
        setTaxResidencyFromDateError('');
    }

    const _handleUpdateTaxResidencyTo = (date) => {
        setTaxResidencyToDate(date);
        setTaxResidencyToDateError('');
    }

    //validation
    const _handleUpdateDetails = () => {
        let is_valid = true;

        // Validate Nationality
        if (!selectedNationality || selectedNationality.length === 0) {
            setNationalityError("Please select your Nationality");
            is_valid = false;
        }

        // Validate Place of Birth
        if (!placeOfBirth || placeOfBirth.trim().length === 0) {
            setPlaceOfBirthError("Please enter place of birth city");
            is_valid = false;
        }

        // Tax related validations for NRI
        if (isNonIndianTaxPayer) {

            // TIN/Reference Number
            if (isTaxProofTIN === false && (!taxReferenceNumber || taxReferenceNumber.trim().length === 0)) {
                setTaxReferenceNumberError("Please enter your TIN");
                is_valid = false;
            }

            // FATCA residency period
            if (!taxResidencyFromDate) {
                setTaxResidencyFromDateError("Please select applicable form");
                is_valid = false;
            }
            if (!taxResidencyToDate) {
                setTaxResidencyToDateError("Please selectapplicable to");
                is_valid = false;
            }
        };

        if (is_valid) {
            // API call
            setLoading(true);
            _updatePersonalDetails();
        }


    }




    //API- Get user data
    const _getUserData = () => {
        let api_version = 2;
        let is_post = false;
        let url = 'kyc/personal-details';
        let data = null;
        let token = sessionStorage.getItem('access_token');

        APIService(is_post, url, data, token, api_version).then((response) => {
            if (response.status_code === 200) {
                setUserData(response.data);
            } else {
                setUserData({});
            }
        });
    };

    //API- Get countries
    const _getCountry = () => {
        let is_post = false;
        let url = 'general/countries';
        let data = null;

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setCountryData(response.data);
            } else {
                setCountryData([]);
            }
        });
    };

    //API- Check kyc status
    const _updatePersonalDetails = () => {

        let api_version = 2;
        let is_post = true;
        let url = 'profile/update-fatca';
        let data = {

            "nationality_country_id": selectedNationality?.id || null,
            "place_of_birth_city": placeOfBirth,
            "tax_reference_number": isNonIndianTaxPayer && isTaxProofTIN === false ? taxReferenceNumber : undefined,
            "tax_residency_from_date": isNonIndianTaxPayer ? format(taxResidencyFromDate, "dd-MM-yyyy") : undefined,
            "tax_residency_to_date": isNonIndianTaxPayer ? format(taxResidencyToDate, "dd-MM-yyyy") : undefined

        };
        let token = sessionStorage.getItem('access_token');

        APIService(is_post, url, data, token, api_version).then((response) => {
            if (response.status_code === 200) {
                setCurrentStep(3);// success
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
            }
            setLoading(false);
        });;
    };

    return (
        <div className="modal fade"
            id="update-kyc-fatca"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="Update kyc-fatca  Modal Label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered ">
                {currentStep !== 3 ?
                    <div className={`${currentStep == 1 ? "mx-4" : ""} modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow`}>
                        <div className="modal-header justify-content-between pt-4  px-4 pb-0 border-0">
                            <h6 className='e-font-16-res mb-2 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                {currentStep == 1 ? "Update your FATCA details" : "Complete your FATCA details"}
                            </h6>
                            <img src={require("../../Assets/Images/close-btn.svg").default}
                                id='family-remove-confirmation-modal-close'
                                draggable={false}
                                className='cursor-pointer'
                                data-bs-dismiss="modal"
                                aria-label="close"
                                alt='close btn'
                                onClick={props.onClose} />
                        </div>
                        <div className="modal-body p-4 pt-3">
                            {
                                currentStep === 1 ?
                                    <>
                                        <p className='e-font-14-res mb-2 e-text-chinese-black e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                                            Please update your FATCA details to continue seamless investments and transactions                        </p>
                                        <PrimaryButton name="Update details"
                                            className="e-border-radius-10 padding-14px-tb e-font-14 padding-8px-tb-res w-100 mt-3"
                                            onPress={() => setCurrentStep(2)} />
                                    </>
                                    :
                                    currentStep === 2 ?
                                        <div>
                                            <div className="row row-gap-4 gx-4">
                                                <div className="col-md-6"
                                                    id='nationality'>
                                                    <CustomTextInput label="Nationality*"
                                                        placeholder="Select nationality"
                                                        className="cursor-pointer"
                                                        dropdown={true}
                                                        type="text"
                                                        isOpen={showNationalityModal}
                                                        value={selectedNationality?.name}
                                                        errorMsg={nationalityError}
                                                        readOnly
                                                        floatingLabel
                                                        disabled={countryData ? false : true}
                                                        onClick={() => setShowNationalityModal(true)} />
                                                </div>
                                                <div className="col-md-6" id='place-of-birth'>
                                                    <CustomTextInput label="Place of birth city*"
                                                        placeholder="Eg: Mumbai"
                                                        type="text"
                                                        floatingLabel
                                                        value={placeOfBirth}
                                                        errorMsg={placeOfBirthError}
                                                        className="w-100"
                                                        handleChange={_handlePlaceOfBirthChange}
                                                    />
                                                </div>
                                            </div>
                                            <hr className="e-text-cool-light-gray opacity-100 my-4" />

                                            {
                                                isNonIndianTaxPayer &&
                                                <>
                                                    <h2 className="e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-500 line-height-24px mb-0">
                                                        Tax residency details
                                                    </h2>
                                                    <div className="row row-gap-4 gx-4 pt-4">
                                                        {
                                                            isTaxProofTIN === false &&
                                                            <div className="col-md-6" id='tax-reference'>
                                                                <CustomTextInput label="Tax reference number(TIN)*"
                                                                    placeholder="FHDC28738"
                                                                    type="text"
                                                                    floatingLabel
                                                                    value={taxReferenceNumber}
                                                                    errorMsg={taxReferenceNumberError}
                                                                    handleChange={_handleChangeTaxReference} />
                                                            </div>
                                                        }
                                                        <div className="col-md-6" id='tax-residency-from-date'>
                                                            <DatePicker
                                                                value={taxResidencyFromDate}
                                                                label="Applicable from*"
                                                                floatingLabel
                                                                minDate={subYears(new Date(), 100)}
                                                                maxDate={new Date()}
                                                                error={taxResidencyFromDateError}
                                                                onChange={_handleUpdateTaxResidencyFrom}
                                                            />
                                                        </div>
                                                        <div className="col-md-6" id='tax-residency-to-date'>
                                                            <DatePicker
                                                                value={taxResidencyToDate}
                                                                label="Applicable to*"
                                                                floatingLabel
                                                                minDate={taxResidencyFromDate || subYears(new Date(), 100)}
                                                                maxDate={null}
                                                                error={taxResidencyToDateError}
                                                                onChange={_handleUpdateTaxResidencyTo}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <PrimaryButton name="Update"
                                                loading={loading}
                                                disabled={loading}
                                                className="e-border-radius-10 padding-14px-tb e-font-14 padding-8px-tb-res w-100 mt-4"
                                                onPress={_handleUpdateDetails} />
                                        </div>
                                        :
                                        ""

                            }
                        </div>
                    </div>
                    :
                    <div className="modal-content e-bg-blur-gradient e-border-radius-24 e-addbank-box-shadow mx-5">
                        <button id='kyc-status-modal-close-btn' data-bs-dismiss="modal" className='d-none'></button>
                        <div className="modal-header border-0 justify-content-end pt-4 pb-0 px-4 ">
                            <img src={require("../../Assets/Images/close-btn-white.svg").default}
                                id='kyc-status-modal-close'
                                width={32}
                                height={32}
                                draggable={false}
                                className='cursor-pointer'
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                alt='close'
                                onClick={props.onCloseModal}
                            />
                        </div>
                        <div className="modal-body text-center p-4 ">
                            <img src={Success}
                                draggable={false}
                                className='col-5'
                                alt='Success' />
                            <p className='mb-2 pt-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                FATCA details updated
                            </p>
                            <p className='mb-0 px-md-4 px-sm-0 px-0 e-text-dark-liver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                                Your FATCA information has beenupdated successfully.
                            </p>

                            <div className='padding-40px-top'>
                                <PrimaryButton name={"Continue"}
                                    className="padding-12px-top padding-12px-bottom col-8 e-font-14"
                                    dismiss="modal"
                                    onPress={props.onClose} />
                            </div>
                        </div>
                    </div>
                }

            </div>

            {
                showNationalityModal === true &&
                <SelectionSuggestModal title="Choose a nationality"
                    data={countryData?.countries_for_address || []}
                    type={12}
                    search={true}
                    backdrop={"false"}
                    searchPlaceholder={"Eg : India"}
                    id='select-nationlaity-modal'
                    selectedOption={selectedNationality}
                    onSelectOption={_handleSelectNationality}
                    onModalClose={() => setShowNationalityModal(false)} />
            }
        </div>
    )
}

export default memo(UpdateKYCFATCADetailsModal);